export function remove404meta() {
    const metaDescription = document.head.querySelector("meta[name='robots']");
    if (metaDescription) {
        metaDescription.remove();
    }
}
